module.exports = __webpack_public_path__ + "static/media/SM.a01a7f70.svg";